const isResolvedConfigValue = (value?: string): value is string => {
    const normalizedValue = value?.trim();
    return Boolean(
        normalizedValue
        && !normalizedValue.includes('${VITE_')
        && !normalizedValue.includes('%%VITE_')
    );
};

export const resolveConfigValue = (...values: Array<string | undefined>) =>
    values.find(isResolvedConfigValue)?.trim();

// Runtime values are injected by docker-entrypoint.sh in deployed environments.
// Vite values provide the local .env.local fallback without changing deployment precedence.
export const oktaDetails = {
    authority: resolveConfigValue(window.ENV?.OKTA_ISSUER, import.meta.env.VITE_OKTA_ISSUER),
    client_id: resolveConfigValue(window.ENV?.OKTA_CLIENT_ID, import.meta.env.VITE_OKTA_CLIENT_ID),
    // Don't use client_secret in browser-based flows - PKCE will be used instead.
    redirect_uri: resolveConfigValue(
        window.ENV?.OKTA_REDIRECT_URI,
        import.meta.env.VITE_OKTA_REDIRECT_URI,
        `${window.location.origin}/login/callback`
    ),
    post_logout_redirect_uri: resolveConfigValue(
        window.ENV?.OKTA_POST_LOGOUT_REDIRECT_URI,
        import.meta.env.VITE_OKTA_POST_LOGOUT_REDIRECT_URI,
        `${window.location.origin}/`
    ),
};
const configuredApiUrl = resolveConfigValue(window.ENV?.API_URL, import.meta.env.VITE_API_URL);

const isLocalBackendEnabled = String(import.meta.env.VITE_USE_LOCAL_BACKEND).toLowerCase() === 'true';
const normalizeLocalBackendApiUrl = (apiUrl: string) => {
    const normalizedUrl = apiUrl.trim().replace(/\/+$/, '');

    if (normalizedUrl.endsWith('/v1')) {
        return `${normalizedUrl}/rest`;
    }

    try {
        const url = new URL(normalizedUrl);
        if (!url.pathname || url.pathname === '/') {
            return `${normalizedUrl}/v1/rest`;
        }
    } catch {
        return normalizedUrl;
    }

    return normalizedUrl;
};
const localBackendApiUrl = normalizeLocalBackendApiUrl(
    import.meta.env.VITE_LOCAL_BACKEND_API_URL || 'http://localhost:8080/v1/rest'
);

// Local development can set VITE_USE_LOCAL_BACKEND=true or override VITE_API_URL/public/config.js.
export const backendApiUrl = isLocalBackendEnabled
    ? localBackendApiUrl
    : configuredApiUrl || 'https://apim-na.qa.mypepsico.com/cgf/rd-dtt-service/v1';
